import { DataGrid } from "devextreme-react";
import { Column, HeaderFilter } from "devextreme-react/data-grid";
import { logOut } from "../../../components/Logout";
import { useNavigate } from "react-router-dom";
import httpService from "../../../services/http-service";
import { getAuthToken } from "../../../services/auth-service";
import './CopyUserList.css'

const CopyUserList = ({ userList, setOpenCopyUserList, setCopiedData }) => {
  const navigate = useNavigate();
  const token = getAuthToken();
  let domainName = (url) => url.match(/(?:http(?:s)?:\/\/)?(?:w{3}\.)?([^\.]+)/i)[1];
  let domailURL = window.location.href;
  let pathname = domainName(domailURL);

  const UserAccessList = async (gUserId) => {
    await httpService
      .get(`api/user/get-user-access-by-userid?gUserId=${gUserId}`, {
        headers: { Authorization: `Bearer ${token}`, Domain: `${pathname}` },
      })
      .then((res) => {
        if (res.data.isSuccess) {
          setCopiedData(res.data.data);
          setOpenCopyUserList(false);
        }
      })
      .catch((err) => {
        if (!err?.response) {
          navigate(`/error/500`);
        } else if (err?.response?.status === 401) {
          logOut();
        }
      });
  };
  return (
    <div className="copy-user-popup">
      <div className="copy-user-header">
        <span>Select Another User</span>
        <button className="copy-user-close" onClick={() => setOpenCopyUserList(false)}>
          ×
        </button>
      </div>

      <div className="copy-user-grid">
        <DataGrid
          dataSource={userList}
          height={500}
          showBorders={true}
          rowAlternationEnabled={true}
          hoverStateEnabled={true}
          columnAutoWidth={true}
          allowColumnResizing={true}
          wordWrapEnabled={true}
          paging={{ pageSize: 10 }}
          pager={{
            visible: true,
            showPageSizeSelector: false,
            showNavigationButtons: true,
            displayMode: "full",
          }}
          scrolling={{ mode: "standard" }}
        >
          <HeaderFilter visible={true} allowSearch={true} />

          <Column
            width={120}
            alignment="center"
            cellRender={(rowData) => (
              <button className="copy-btn" onClick={() => UserAccessList(rowData?.data?.gUserId)}>
                Copy
              </button>
            )}
          />

          <Column dataField="sUserId" caption="User Id" width={160} />
          <Column dataField="sFirstName" caption="First Name" width={160}/>
          <Column dataField="sLastName" caption="Last Name" width={160}/>
          <Column
            dataField="bActive"
            caption="Active"
            dataType="boolean"
            width={120}
            alignment="center"
            filterValue={true}
          />
        </DataGrid>
      </div>
    </div>
  );
};

export default CopyUserList;
